"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return createKonvaLayer;
    }
});
const _konva = /*#__PURE__*/ _interop_require_default(require("konva"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function createKonvaLayer({ name = "layer", visible = true, listening = true, onDraw, onMouseMove }) {
    const layer = new _konva.default.Layer({
        name,
        visible,
        listening
    });
    if (listening) {
        onDraw && layer.on("draw", onDraw);
        onMouseMove && layer.on("mousemove", onMouseMove);
    }
    return layer;
}
